import { createStore, combineReducers } from 'redux';
import items from './reducers/items';
import config from './reducers/config';
import search from './reducers/search';

const rootReducer = combineReducers({
    items,
    config,
    search
});

const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
/*
store.subscribe(() => {
   console.log(store.getState());
})
*/
export default store;


// WEBPACK FOOTER //
// ./src/app/utils/store.js